export default __webpack_public_path__ + "static/media/eyeClosed.9931c116.svg";